import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import { IoMdArrowDropright } from "react-icons/io";
import DeleteIcon from "@mui/icons-material/Delete";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ConfirmationModal from "../../../components/Staff/Modals/ConfirmationModal";
import Select from "react-select";
import ClipLoader from "react-spinners/ClipLoader";
import Cookies from "js-cookie";


const ProjectStatus = () => {
  const [open11, setOpen11] = useState(false);
  const onOpenModal11 = () => setOpen11(true);
  const onCloseModal11 = () => setOpen11(false);
  const { baseUrl, openToast } = useGlobalContext();
  const [openIndex, setOpenIndex] = useState(null);
  const [projectPriorityDetail, setProjectPriorityDetail] = useState();
  const [id, setId] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  async function fetchProjectPriority() {
    try {
      setIsLoading(true)
      const result = await fetch(baseUrl + "project-Priority", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        }
      }
      );
      const data = await result.json();
      if (result.status === 200) {
        setProjectPriorityDetail(data?.data);
      } else {
        console.error(data.message || "An unexpected error occured");
        setProjectPriorityDetail([]);
      }
    } catch (error) {
      console.log("some error occured", error);
    }
    finally {
      setIsLoading(false)

    }
  }

  async function fetchProjectDetails() {
    try {
      setIsLoading(true)
      const result = await fetch(baseUrl + "project-status", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        }
      }
      );
      const data = await result.json();
      setFetchProjectStatus(data.data);
    } catch (error) {
      openToast("Error", "error")
    }
    finally {
      setIsLoading(false)
    }
  }
  const [selectedCanBeChanged, setSelectedCanBeChanged] = useState([]);

  const handleUpdate = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        baseUrl + "project-status/" + selectedPriority.id,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
          },
          body: JSON.stringify({
            project_name: selectedPriority.project_name,
            project_color: selectedPriority.project_color,
            project_order: selectedPriority.project_order,
            default_filter: selectedPriority.default_filter,
            is_hidden: selectedPriority.is_hidden,
            can_changed: selectedCanBeChanged.map((item) => item.value),
          }),
        }
      );
      const data = await response.json();
      if (response.status === 200) {
        openToast(data.message, "success");
        setIsLoading(false);
        fetchProjectDetails();
        setSelectedPriority(null);
      } else {
        openToast(data.message, "error");
      }
    } catch (error) {
      openToast(error.message, "error");
    }
    finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      setIsLoading(true)
      const response = await fetch(baseUrl + "project-status/" + id, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        },
      });
      const data = await response.json();
      if (response.status === 200) {
        openToast(data.message, "success");
        fetchProjectDetails();
        setOpen11(false);
      } else {
        openToast(data.message, "error");
      }
    } catch (error) {
      openToast(error.message, "error");
    }
    finally{
      setIsLoading(false)
    }
  };

  useEffect(() => {
    fetchProjectPriority();
  }, []);
  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };
  const exportCSV = () => {
    const csvData = projectPriorityDetail
      .map(
        (dep) =>
          `${dep.Priority_name}, ${dep.Priority_color}, ${dep.Priority_order}`
      )
      .join("\n");
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "ProjectStatus.csv");
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("AllTaskStatus", 20, 10);
    projectPriorityDetail.forEach((dep, index) => {
      doc.text(
        `${index + 1}. ${dep.Priority_name},${dep.project_color},${dep.Priority_order
        }`,
        10,
        20 + index * 10
      );
    });
    doc.save("ProjectStatus.pdf");
  };

  const printDepartments = () => {
    const printContent = projectPriorityDetail
      .map(
        (dep) =>
          `${dep.Priority_name},${dep.Priority_color}, ${dep.Priority_order} (Total Users: 1)`
      )
      .join("\n");
    const newWindow = window.open();
    newWindow.document.write(`<pre>${printContent}</pre>`);
    newWindow.document.close();
    newWindow.print();
  };
  const [rowsToShow, setRowsToShow] = useState(25);
  const handleExport = () => {
    if (exportFormat === "CSV") exportCSV();
    else if (exportFormat === "PDF") exportPDF();
    else if (exportFormat === "Print") printDepartments();
  };
  const [exportFormat, setExportFormat] = useState("");
  //salary dropdown
  const [isOpen1, setIsOpen1] = useState(false);

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1);
  };

  //salary dropdown

  //Toggle swich off on btn
  const [isOn, setIsOn] = useState(false);

  const toggleSwitch = () => {
    setIsOn(!isOn);
  };

  //Toggle swich off on btn

  //Modal
  // State to control the visibility of the modal
  const [isOpen, setIsOpen] = useState(false);

  // Function to toggle the modal
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  //Modal2
  //Modal
  // State to control the visibility of the modal
  const [isOpen3, setIsOpen3] = useState(false);

  // Function to toggle the modal
  const toggleModal3 = () => {
    setIsOpen3(!isOpen3);
  };

  //Modal2
  const [isOpen5, setIsOpen5] = useState(true);

  // Toggle the visibility of tbody
  const toggleTable = () => {
    setIsOpen5(!isOpen5);
  };
  let subtitle;

  const [modalIsOpen6, setIsOpen6] = React.useState(false);
  function openModal6() {
    setIsOpen6(true);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal6() {
    setIsOpen6(false);
  }
  const [projectName, setProjectName] = useState();
  const [projectColor, setProjectColor] = useState();
  const [projectOrder, setProjectOrder] = useState();
  const [filter, setFilter] = useState(false);
  const [canChanged, setCanChanged] = useState([]);

  async function submitProjectStatus() {
    setIsLoading(true);
    try{
      const result = await fetch(baseUrl + "project-status", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        },
        body: JSON.stringify({
          project_name: projectName,
          project_color: projectColor || "black",
          project_order: parseInt(projectOrder),
          default_filter: filter,
          can_changed: canChanged,
        }),
      });
      const data = await result.json();
      if (result.status == 201) {
        openToast(data.message || "Add Project Status Successfully", "success");
        setIsLoading(false);
        setIsOpen(false);
        fetchProjectDetails();
        closeModal6();
      } else {
        openToast(data.message || "An internal server error occured", "error");
      }
    }
    catch(error){
      openToast("error while adding project status" , "error")
    }
    finally{
       setIsLoading(false);
    }
  }

  const [fetchProjectStatus, setFetchProjectStatus] = useState([]);

  useEffect(() => {
    fetchProjectDetails();
  }, []);
  return (
    <div className="w-full">
      <div className="bg-[#fff] p-[10px]">
        <div className="shadow-cs p-[20px] rounded-lg w-full">
          <div className="flex items-center gap-[14px] mb-[10px]">
            <div className="flex justify-center items-center h-[50px] text-[14px]">
              {/* Button to open the modal */}
              <button
                onClick={toggleModal}
                className="second-btn"
              >
                Add Project Status
              </button>

              {/* Modal (visible only when isOpen is true) */}
              {isOpen && (
                <div className="z-[1] fixed inset-0 flex justify-center items-center bg-gray-800 bg-opacity-50">
                  <div className="bg-white shadow-lg rounded-lg w-96">
                    {/* Modal Header */}
                    <div className="px-4 py-2 border-b">
                      <h2 className="font-semibold text-lg"> Project Status</h2>
                    </div>

                    {/* Modal Body */}
                    <div className="p-4">
                      <div className="mb-[10px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">*Project Name</label>
                        <br />
                        <input
                          type="text"
                          onChange={(e) => setProjectName(e.target.value)}
                          placeholder=""
                          className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
                        />
                      </div>
                      <div className="mb-[10px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">*Project Color</label>
                        <br />
                        <input
                          type="color"
                          onChange={(e) => setProjectColor(e.target.value)}
                          placeholder=""
                          className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
                        />
                      </div>
                      <div className="mb-[10px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">*Project Order</label>
                        <br />
                        <input
                          type="text"
                          onChange={(e) => setProjectOrder(e.target.value)}
                          placeholder=""
                          className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
                        />
                      </div>
                      <div className="flex items-center gap-[6px] mb-[10px]">
                        <input
                          type="checkbox"
                          onChange={(e) => setFilter(e.target.checked)}
                        />

                        <p>Default Filter</p>
                      </div>
                      <div className="mb-[20px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">Can be changed to</label>
                        <br />
                        <Select
                          isMulti
                          placeholder="Can be changed to"
                          options={
                            fetchProjectStatus
                              ? fetchProjectStatus?.map((item, index) => {
                                return {
                                  value: item.id,
                                  label: item.project_name,
                                };
                              })
                              : []
                          }
                          onChange={(e) =>
                            setCanChanged(e.map((item) => item?.value))
                          }
                          className="w-full h-[40px] newsetup3"
                          required
                        />
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="flex justify-end gap-[10px] px-4 py-2 border-t">
                      <button onClick={toggleModal} className="first-btn">
                        Cancel
                      </button>
                      <button
                        onClick={submitProjectStatus}
                        className={` ${ isLoading == true ? "second-btn-disabled" : "second-btn"}`}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="flex md:flex-row lg:flex-row xl:flex-row flex-col justify-between items-start gap-[10px] mb-[14px]">
            <div className="flex items-center gap-[10px]">
              <div className="inline-block relative text-left">
                {/* Button to open/close the dropdown */}
                <select
                  onChange={handleSelectChange}
                  className="border-[#e5e7eb] shadow-sm mr-2 p-[7px] pr-3 border rounded-md text-[14px] focus:outline-none"
                >
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="120">120</option>
                </select>

                {/* Dropdown menu */}
                {isOpen1 && (
                  <div className="right-0 left-[0px] z-10 absolute border-gray-200 bg-white shadow-lg mt-2 border rounded-md w-[100%] origin-top-right">
                    <div
                      className=""
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        30
                      </a>
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        40
                      </a>
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        50
                      </a>
                    </div>
                  </div>
                )}
              </div>

              <select
                onChange={(e) => setExportFormat(e.target.value)}
                className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md text-[14px] text-sm focus:outline-none"
              >
                <option value="CSV">CSV</option>
                <option value="PDF">PDF</option>
                <option value="Print">Print</option>
              </select>
              <button
                onClick={handleExport}
                className="second-btn"
              >
                Export
              </button>
            </div>
            <div className="relative w-full md:w-[200px] lg:w-[200px] xl:w-[200px]">
              <input
                className="p-[6px] pr-[25px] summary-border rounded-2xl w-full text-[13px]"
                type="text"
                placeholder=" Search......."
              />
              <SearchIcon className="top-[8px] right-[8px] absolute newadd2" />
            </div>
          </div>

          <div className="border-[#dcdbdb] bg-white shadow-cs border rounded-lg w-full overflow-x-auto">
            <table className="rounded-md w-full table-auto table-status">
              <thead
                onClick={toggleTable}
                className="set-shadow cursor-pointer"
              >
                <tr>
                  <th className="flex justify-center items-center p-3 border-r font-medium text-center text-xs whitespace-nowrap">
                    <IoMdArrowDropright
                      className={`text-[20px] transition-transform duration-200 ${isOpen5 ? "rotate-90 text-[black]" : "rotate-0"
                        }`}
                    />
                  </th>
                  <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                    ID
                  </th>
                  <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                    Project Name
                  </th>
                  <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                    Project Color
                  </th>
                  <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                    Project Order
                  </th>
                  <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                    {" "}
                    Default Filter
                  </th>
                  <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                    Project can be changed to
                  </th>
                  <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                    Action
                  </th>
                </tr>
              </thead>
              {/* Add transition for tbody */}
              <tbody
                className={`transition-all duration-500 ease-in-out overflow-hidden ${isOpen5 ? "max-h-screen" : "max-h-0"
                  }`}
                style={{ display: isOpen5 ? "table-row-group" : "none" }}
              >
                {

                  isLoading && fetchProjectStatus.length === 0 ? (
                    <tr className="h-[100px]">
                      <td
                        colSpan="10"
                        className="py-4 font-semibold text-center text-gray-600 text-sm"
                      >
                        <ClipLoader color="#27004a" size={50} />
                      </td>
                    </tr>
                  ) : fetchProjectStatus && fetchProjectStatus.length > 0 ?
                    fetchProjectStatus?.map((fetchProjectDetail, index) => {
                      return (
                        <tr className="border">
                          <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                            #
                          </td>
                          <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                            {index + 1}
                          </td>
                          <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                            {fetchProjectDetail?.project_name}
                          </td>
                          <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                            {fetchProjectDetail?.project_color}
                          </td>
                          <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                            {fetchProjectDetail?.project_order}
                          </td>
                          <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                            Yes
                          </td>
                          <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                            In Progress
                          </td>
                          <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                            <div className="flex justify-center gap-2">
                              <button
                                className="rounded-md text-white"
                                onClick={() => {
                                  setSelectedPriority(fetchProjectDetail);
                                }}
                              >
                                <BorderColorIcon className="text-[#27004a] text-xl" />
                              </button>
                              <div>
                                <button
                                  onClick={() => {
                                    setOpen11(true);
                                  }}
                                >
                                  <DeleteIcon className="text-red-500 cursor-pointer" />
                                </button>
                                {open11 && (
                                  <ConfirmationModal
                                    setClose={onCloseModal11}
                                    id={fetchProjectDetail.id}
                                    callback={handleDelete}
                                  />
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                    )
                    : (
                      <tr className="h-[100px]">
                        <td
                          colSpan="10"
                          className="py-4 font-semibold text-center text-red-500 text-sm"
                        >
                          Project Status Not Found
                        </td>
                      </tr>
                    )

                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal
        isOpen={selectedPriority !== null}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal6}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="border-[#000] p-3 border-b text-[14px]"
        >
          Edit New Task
        </h2>
        <button
          onClick={() => setSelectedPriority(null)}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>

        <div className="first-panel">
          <div className="p-4">
            <div className="mb-[10px] w-[100%] xl:[48%]">
              <label className="text-[14px]">*Status Name</label>
              <br />
              <input
                type="text"
                placeholder=""
                value={selectedPriority?.project_name}
                onChange={(e) => {
                  setSelectedPriority({
                    ...selectedPriority,
                    project_name: e.target.value,
                  });
                }}
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
              />
            </div>
            <div className="mb-[10px] w-[100%] xl:[48%]">
              <label className="text-[14px]">*Status Color</label>
              <br />
              <input
                type="color"
                placeholder=""
                value={selectedPriority?.project_color}
                onChange={(e) => {
                  setSelectedPriority({
                    ...selectedPriority,
                    project_color: e.target.value,
                  });
                }}
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
              />
            </div>
            <div className="mb-[10px] w-[100%] xl:[48%]">
              <label className="text-[14px]">*Status Order</label>
              <br />
              <input
                type="text"
                placeholder=""
                value={selectedPriority?.project_order}
                onChange={(e) => {
                  setSelectedPriority({
                    ...selectedPriority,
                    project_order: e.target.value,
                  });
                }}
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
              />
            </div>
            <div className="flex items-center gap-[6px] mb-[10px]">
              <input
                type="checkbox"
                checked={selectedPriority?.default_filter}
                onChange={(e) => {
                  setSelectedPriority({
                    ...selectedPriority,
                    default_filter: e.target.checked,
                  });
                }}
              />
              <p>Default Filter</p>
            </div>

            <div className="mb-[20px] w-[100%] xl:[48%]">
              <label className="text-[14px]">Can be changed to</label>
              <br />
              <Select
                isMulti
                placeholder="Can be changed to"
                options={
                  fetchProjectStatus
                    ? fetchProjectStatus.map((item, index) => {
                      return {
                        value: item.id,
                        label: item.project_name,
                      };
                    })
                    : []
                }
                onChange={(e) => setSelectedCanBeChanged(e)}
                className="w-full h-[40px]"
                required
              />
            </div>
          </div>

          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
            <button
              className="first-btn"
              onClick={() => setSelectedPriority(null)}
            >
              Cancel
            </button>
            <button onClick={handleUpdate} className={`${isLoading?"second-btn-disabled":"second-btn"}`}>
              Confirm
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ProjectStatus;
